/* The mockup's `.state`: centred, no frame, a round glyph above a 16/600 title. */
.state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-12) var(--space-6);
  text-align: center;
  color: var(--text);
}

.icon {
  display: grid;
  place-items: center;
  inline-size: 40px;
  block-size: 40px;
  margin-block-end: var(--space-2);
  border-radius: 50%;
  background: var(--surface-sunken);
  color: var(--text-muted);
}

.title {
  margin: 0;
  font-size: var(--font-size-16);
  font-weight: var(--font-weight-semibold);
}

.body {
  margin: 0;
  max-inline-size: 44ch;
  color: var(--text-muted);
  line-height: var(--line-height-body);
}

.action {
  display: flex;
  gap: var(--space-2);
  margin-block-start: var(--space-3);
}
